import {Box} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {useSessionQuery} from "./app/api/api";
import MainAppBar from "./components/MainAppBar";
import RequireAuth from "./components/RequireAuth";
import Login from "./features/auth/Login";
import Users from "./features/users";
import Devices from "./features/devices";
import UpdatePassword from "./features/auth/UpdatePassword";
import Firmwares from "./features/firmwares";
import Orders from "./features/orders";
import {RoutePath} from "./types";
import Organizations from "./features/organizations";
import Shipments from "./features/shipments";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Settings from "./features/settings";
import Terminations from "./features/terminations";
import Assets from "./features/assets";
import CompanyCards from "./features/companyCards";

function App() {
    return (
        <Routes>
            <Route path={`/${RoutePath.LOGIN}`} element={<Login />} />
            <Route path="/*" element={<Internal />} />
        </Routes>
    );
}

export default App;

function Internal() {
    const {data: session, isError: isSessionError, isLoading: isSessionLoading} = useSessionQuery();

    dayjs.extend(utc);

    return (
        <Box sx={{display: "flex"}}>
            {!isSessionError && session && !isSessionLoading && <MainAppBar />}
            <Box component="main" sx={{flexGrow: 1, p: 3, pt: 10, overflowX: "hidden"}}>
                <Routes>
                    <Route path="/" element={<RequireAuth />} />
                    <Route path={`/${RoutePath.USERS}/*`} element={<Users />} />
                    <Route path={`/${RoutePath.ORGANIZATIONS}/*`} element={<Organizations />} />
                    <Route path={`/${RoutePath.ASSETS}/*`} element={<Assets />} />
                    <Route path={`/${RoutePath.DEVICES}/*`} element={<Devices />} />
                    <Route path={`/${RoutePath.ORDERS}/*`} element={<Orders />} />
                    <Route path={`/${RoutePath.TERMINATIONS}/*`} element={<Terminations />} />
                    <Route path={`/${RoutePath.SHIPMENTS}/*`} element={<Shipments />} />
                    <Route path={`/${RoutePath.FIRMWARES}/*`} element={<Firmwares />} />
                    <Route path={`/${RoutePath.SETTINGS}/*`} element={<Settings />} />
                    <Route path={`/${RoutePath.PASSWORD}`} element={<UpdatePassword />} />
                    <Route path={`/${RoutePath.COMPANYCARDS}`} element={<CompanyCards />} />
                </Routes>
            </Box>
        </Box>
    );
}
